<template>
  <transition
    enter-active-class="transition duration-500 ease-out"
    enter-from-class="opacity-0 scale-95 translate-y-4"
    enter-to-class="opacity-100 scale-100 translate-y-0"
    leave-active-class="transition duration-300 ease-in"
    leave-from-class="opacity-100 scale-100 translate-y-0"
    leave-to-class="opacity-0 scale-95 translate-y-4"
  >
    <div v-if="showPopup" class="fixed bottom-6 left-6 z-[1000] w-full max-w-sm">
      <div class="relative bg-white rounded-2xl shadow-2xl border border-slate-100 overflow-hidden">
        <!-- Close Button -->
        <button @click="dismiss" class="absolute top-3 right-3 text-slate-400 hover:text-slate-600 z-10 bg-white/50 rounded-full p-1">
          <component :is="XIcon" class="w-4 h-4" />
        </button>

        <div class="bg-slate-900 p-6 text-white text-center relative overflow-hidden">
           <div class="absolute top-0 right-0 w-32 h-32 bg-red-600/20 rounded-full blur-2xl"></div>
           <component :is="MailOpenIcon" class="w-8 h-8 text-red-500 mx-auto mb-3" />
           <h3 class="text-lg font-bold mb-1">Get 10% Off Your First Order</h3>
           <p class="text-xs text-slate-300">Subscribe for new item notifications, exclusive safety deals, and updates.</p>
        </div>

        <div class="p-6">
          <div v-if="success" class="p-3 rounded-lg bg-emerald-50 text-emerald-600 text-xs font-bold text-center">
            Thanks for subscribing! Check your email.
          </div>
          <div v-else class="space-y-3">
            <input 
              v-model="email" 
              type="email" 
              placeholder="Enter your email address" 
              class="w-full h-10 px-4 rounded-lg bg-slate-50 border border-slate-100 text-xs font-medium text-slate-900 focus:bg-white focus:border-slate-900 focus:outline-none transition-all text-center" 
            />
            <button 
              @click="subscribe" 
              :disabled="loading || !email"
              class="w-full h-10 bg-slate-900 hover:bg-black text-white font-bold rounded-lg uppercase tracking-widest text-[10px] transition-all flex items-center justify-center gap-2 disabled:opacity-50"
            >
              <span v-if="!loading">Subscribe Now</span>
              <div v-else class="w-4 h-4 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
            </button>
            <p class="text-[9px] text-slate-400 text-center mt-2">By subscribing, you agree to our terms and privacy policy.</p>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { X as XIcon, MailOpen as MailOpenIcon } from 'lucide-vue-next'
import { useTrackingStore } from '~/stores/tracking'

const trackingStore = useTrackingStore()
const showPopup = ref(false)
const email = ref('')
const loading = ref(false)
const success = ref(false)

onMounted(() => {
  if (process.client) {
    const hasSeen = localStorage.getItem('newsletter_seen')
    if (!hasSeen) {
      setTimeout(() => {
        showPopup.value = true
      }, 10000) // Show after 10 seconds
    }
  }
})

const dismiss = () => {
  showPopup.value = false
  if (process.client) {
    localStorage.setItem('newsletter_seen', 'true')
  }
}

const subscribe = async () => {
  if (!email.value) return
  loading.value = true
  
  try {
    await trackingStore.captureLead({
      email: email.value,
      source: 'Newsletter Popup'
    })
    
    success.value = true
    setTimeout(() => {
      dismiss()
    }, 3000)
  } catch (error) {
    console.error('Subscription error', error)
  } finally {
    loading.value = false
  }
}
</script>
